import React, { type PropsWithChildren, useState } from 'react';

import {
	SetWillRedirectOnLoadContext,
	WillRedirectOnLoadContext,
} from '../will-redirect-on-load-contexts';

export const WillRedirectOnLoadProviders = ({ children }: PropsWithChildren): React.JSX.Element => {
	const [willRedirectOnLoad, setWillRedirectOnLoad] = useState(false);

	return (
		<WillRedirectOnLoadContext.Provider value={willRedirectOnLoad}>
			<SetWillRedirectOnLoadContext.Provider value={setWillRedirectOnLoad}>
				{children}
			</SetWillRedirectOnLoadContext.Provider>
		</WillRedirectOnLoadContext.Provider>
	);
};
